import { render, staticRenderFns } from "./AtlasSharingUserRow.vue?vue&type=template&id=736bc0a7&scoped=true&"
import script from "./AtlasSharingUserRow.vue?vue&type=script&lang=js&"
export * from "./AtlasSharingUserRow.vue?vue&type=script&lang=js&"
import style0 from "./AtlasSharingUserRow.vue?vue&type=style&index=0&id=736bc0a7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736bc0a7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VIcon,VSelect})
